var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"id":"bottomMenu"}},[_c('ButtonGroup',[_c('Button',{on:{"click":_vm.saveToGeojson}},[_vm._v("\n      Save\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }